module.exports = __webpack_public_path__ + "static/media/hcn-cloud-challenge-new.8a347ac9.svg";